import { lazy } from "react";
import {usrPermission} from "../../config/userPermission";

const Exhibitors = lazy(() => import("./pages/Exhibitors"));

export const routes: any = [
    {
        path: "exhibitors",
        permission: usrPermission.exhibitors.r,
        element: <Exhibitors />,
    },
];
